<mat-form-field class="w-100" appearance="outline" color="primary">
  <mat-label>{{ 'COMMON.SEARCH-BY-NAME-PHONE-ID' | translate }} </mat-label>
  <input type="text" #textInput matInput class="form-control" autofocus [value]="searchText">
  <mat-icon matSuffix (click)="search(textInput)">search</mat-icon>
</mat-form-field>